import { InjectionToken } from '@angular/core';
import { NestedEndpoints } from '@ird/shared-utils';

export const FeatureEndpoints = new InjectionToken<NestedEndpoints>('ENDPOINTS');
